import React from 'react'
import { Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components'

export const ModalConfirmarAcao = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    titulo,
    mensagem,
    confirmarLabel = 'Confirmar',
    confirmarColor = 'secondary'
  } = props

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      titulo={titulo}
      confirmarLabel={confirmarLabel}
      confirmarColor={confirmarColor}
      maxWidth="xs"
    >
      {mensagem && (
        <Typography variant="body1" style={{ marginTop: '10px' }}>
          {mensagem}
        </Typography>
      )}
    </ModalConfirmacao>
  )
}
